import types from '../actionTypes';

export const addInfoCategoryRequest = (form, payload) => ({
    type: types.ADD_INFO_CATEGORY_REQUEST,
    meta: {
        form,
    },
    payload,
});

export const addInfoRequest = (form, categoryId, payload) => ({
    type: types.ADD_INFO_REQUEST,
    meta: {
        form,
        categoryId,
    },
    payload,
});
